import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-权限管理",
  "use": "icon-权限管理-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-权限管理\">\r\n<path d=\"M100,17.3L29.5,45.5v56.4c0,38.6,25.2,70.5,62.1,84.6c8.4,3.2,8.6,3.2,16.9,0c36.9-14.2,62.1-46,62.1-84.6V45.5L100,17.3z\r\n\t M90.6,132.7l-26.2-26.5l9-9.1l17.3,17.4l43-43.4l9,9.1L90.6,132.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol